import React from 'react';
import { Route } from 'react-router-dom';
import AppCreatePassword from '../Resources/Auth/AppCreatePassword';

export default [<Route path="/auth/create-password" component={AppCreatePassword} noLayout />];
